var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing-email-form-models-section"},[_c('h1',{staticClass:"marketing-email-form-models-section-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"marketing-email-form-models-section-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }